export default __webpack_public_path__ + "static/media/Lazy_Horse_Survivor.2b9a4fd5.png";